
import React, {Component} from 'react'
import Link from 'gatsby-link';
import styles from './background.module.css';
import CategoryGallery from '../CategoryGallery';
import Carousel from '../Carousel';
import WhyUs from '../WhyUs';
import { Divider, Container, Header } from 'semantic-ui-react';

const gap = (num) => {
  return Array.from(Array(num).keys()).map( x => {return <Divider key={x} hidden />});
}

const Home = () => {

  return (
    <Container fluid>
    <section className={styles.hero}>
      {gap(5)}
      <Container textAlign='center'>
      <Header inverted size='huge' as='h3'>EXPLORE YOUR FUTURE</Header>
      <Header inverted size='huge' as='h1'>We Are Commited to Excellence Education. <br/>Pursuade Your Dream with Us</Header>
      </Container>
      <Link className={styles.btn} to="/courses/">GET STARTED NOW</Link>
      {gap(3)}
    </section>
    <WhyUs />
    </Container>
  )
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.js